export enum AttachmentType {
  File,
  URL,
  Template,
}
